import { HttpContext } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/api/api.service';
import { CATEGORIES_ENDPOINTS } from 'src/app/core/api/endpoints/categories.endpoints';
import { BUTTON_LOADING_ID } from 'src/app/shared/global/http-context-tokens';

@Injectable({
  providedIn: 'root',
})
export class CategoriesService {
  private api = inject(ApiService);

  addCategory(serviceId: any, data: any): Observable<any> {
    return this.api.post(
      CATEGORIES_ENDPOINTS.V1.SERVICE_CATEGORIES(serviceId),
      data
    );
  }

  updateCategory(categoryId: any, data: any): Observable<any> {
    return this.api.put(
      CATEGORIES_ENDPOINTS.V1.CATEGORY_DETAIL(categoryId),
      data
    );
  }

  getCategoriesByService(serviceId: any): Observable<any> {
    const params = { page_size: 30 };
    return this.api.get(
      CATEGORIES_ENDPOINTS.V1.SERVICE_CATEGORIES(serviceId),
      { params: params }
    );
  }

  createCategoriesRatio(serviceId: any, data: any): Observable<any> {
    const requestBody = {
      categories: data
    }
    return this.api.post(CATEGORIES_ENDPOINTS.V1.CATEGORIES_BULK(serviceId), requestBody);
  }

  changeTermCategory(termId: any, data: any) {
    return this.api.patch(
      CATEGORIES_ENDPOINTS.V1.TERM_DETAIL(termId),
      data
    );
  }

  deleteCategory(categoryId: any): Observable<any> {
    return this.api.delete(
      CATEGORIES_ENDPOINTS.V1.CATEGORY_DETAIL(categoryId)
    );
  }

  createIndexation(data: any, buttonId: any): Observable<any> {
    return this.api.post(CATEGORIES_ENDPOINTS.V1.INDEXATIONS, data, {
      context: new HttpContext().set(BUTTON_LOADING_ID, buttonId)
    });
  }

  updateIndexation(data: any, id: any): Observable<any> {
    return this.api.put(CATEGORIES_ENDPOINTS.V1.INDEXATION_DETAIL(id), data);
  }
}
